import React from 'react'

import TextArea from '../Fields/TextArea'
import Checkbox from '../Fields/Checkbox'

import content from '../../assets/content/IVDrugs.json'
import classes from './layout.css'

const ModuleTwentySeven = (props) => {
	return (
		<div className={classes.Container}>
			<ol>
				{content.map((item, index) => {
					let itemNumber = index + 1
					let itemName =`cBox${itemNumber}`
					return (
						<li key={index}>
							<Checkbox
								controlFunc={props.addToForm}
								name={itemName}
								value={props.consentForm[itemName]}
							/>{item}
						</li>
					)
				})}
				<li className={classes.ListItem}>
					<Checkbox
						controlFunc={props.addToForm}
						id={"initial"}
						name={"cBox9"}
						value={props.consentForm.cBox9.initial}
					/>
					I have read the information above and understand the possible risks of having my planned treatment. I understand and agree to the following treatment plan:
					<TextArea
						controlFunc={props.addToForm}
						inputType={"text"}
						name={"cBox9"}
						id={"description"}
						value={props.consentForm.cBox9.description}
					/>
				</li>

				<li className={classes.ListItem}>
					<Checkbox
						controlFunc={props.addToForm}
						name={"cBox10"}
						value={props.consentForm.cBox10}
					/>
					I understand the importance of my health history and I have given you all information. I understand that if I don’t give you true and complete health information, it may be harmful to my care and lead to unwanted complications.
				</li>

				<li className={classes.ListItem}>
					<Checkbox
						controlFunc={props.addToForm}
						name={"cBox11"}
						value={props.consentForm.cBox11}
					/>
					I realize that even though the doctors will take all precautions to avoid complications the doctor can’t guarantee the result of the proposed treatment.
				</li>
			</ol>

		</div>
	)
}

export default ModuleTwentySeven


// WEBPACK FOOTER //
// ./src/components/Modules/27.js